<template>
    <section class="py-20">
        <div ref="blob1" class="blob-gradient blob1"></div>
        <div ref="blob2" class="blob-gradient blob2"></div>
        <div ref="blob3" class="blob-gradient blob3"></div>
        <div class="container mx-auto px-4 relative z-10">
            <div class="text-center mb-16">
                <h2 class="section-title text-slate-700 dark:text-slate-300">About Me</h2>
                <p class="section-subtitle text-slate-700 dark:text-slate-400">Getting to Know Me and My Experience More
                    Closely</p>
            </div>
            <div class="grid md:grid-cols-2 gap-12 items-center">
                <div class="animate-slide-up">
                    <div class="bg-gradient-to-br text-slate-700 dark:text-slate-300 rounded-2xl p-8">
                        <div
                            class="w-64 h-64 mx-auto bg-slate-300 dark:bg-slate-800/50 rounded-full flex items-center justify-center p-2 shadow-lg">
                            <img src="https://avatars.githubusercontent.com/u/71551322?v=4" alt="Profile Image"
                                class="w-full h-full object-cover rounded-full">
                        </div>
                        <!-- Social Links -->
                        <div class="flex justify-center gap-6 mt-5">
                            <a href="https://github.com/bahriyanto31" target="_blank" rel="noopener"
                                class="text-2xl transition-colors hover:underline">
                                <i class="fab fa-github"></i>
                                Github
                            </a>
                            <a href="https://linkedin.com/in/bahriyantoanang" target="_blank" rel="noopener"
                                class="text-2xl transition-colors hover:underline">
                                <i class="fab fa-linkedin"></i>
                                Linkedin
                            </a>
                        </div>
                    </div>
                </div>
                <div class="animate-slide-up">
                    <h3 class="text-2xl font-bold mb-4 text-slate-700 dark:text-slate-300">Developer & Designer</h3>
                    <p class="text-secondary-600 dark:text-secondary-400 mb-6 leading-relaxed">
                        I'm Bahriyanto Anang, a passionate web developer with solid expertise in PHP and frameworks like
                        CodeIgniter 3/4 and Laravel, as well as modern frontend technologies such as Vue.js and Nuxt.js.
                        My experience includes building a real-time, centralized attendance system for a local
                        government and delivering several successful projects at a software development company. These
                        roles sharpened my skills in scalable solution development, effective collaboration, and
                        continuous learning. I'm always eager to explore new technologies and contribute to impactful,
                        user-friendly web applications.
                    </p>
                    <div class="grid grid-cols-2 gap-4">
                        <div class="text-center p-4 bg-secondary-50 dark:bg-secondary-900 rounded-lg">
                            <div class="text-2xl font-bold text-primary-600">3+</div>
                            <div class="text-sm text-secondary-600">Tahun Pengalaman</div>
                        </div>
                        <div class="text-center p-4 bg-secondary-50 dark:bg-secondary-900 rounded-lg">
                            <div class="text-2xl font-bold text-primary-600">20+</div>
                            <div class="text-sm text-secondary-600">Proyek Selesai</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue'
export default {
    data() {
        return { projects: [] }
    },
    async created() {
        const res = await fetch('/src/projects.json')
        if (res.ok) {
            this.projects = await res.json()
        }
    },
    setup() {
        const blob1 = ref(null)
        const blob2 = ref(null)
        const blob3 = ref(null)
        let mouseX = window.innerWidth / 2
        let mouseY = window.innerHeight / 2
        let animationId

        function onMouseMove(e) {
            mouseX = e.clientX
            mouseY = e.clientY
        }

        function animateBlobs() {
            const t = Date.now() * 0.001
            // Blob 1: radius 80px, sudut dinamis
            if (blob1.value) {
                const angle = t * 1.2
                const x = mouseX + Math.cos(angle) * 80 - 110
                const y = mouseY + Math.sin(angle) * 80 - 110
                blob1.value.style.left = `${x}px`
                blob1.value.style.top = `${y}px`
            }
            // Blob 2: radius 120px, sudut dinamis + offset
            if (blob2.value) {
                const angle = t * 0.9 + 2
                const x = mouseX + Math.cos(angle) * 120 - 110
                const y = mouseY + Math.sin(angle) * 120 - 110
                blob2.value.style.left = `${x}px`
                blob2.value.style.top = `${y}px`
            }
            // Blob 3: radius 60px, sudut dinamis + offset
            if (blob3.value) {
                const angle = t * 1.5 - 1
                const x = mouseX + Math.cos(angle) * 60 - 110
                const y = mouseY + Math.sin(angle) * 60 - 110
                blob3.value.style.left = `${x}px`
                blob3.value.style.top = `${y}px`
            }
            animationId = requestAnimationFrame(animateBlobs)
        }

        onMounted(() => {
            window.addEventListener('mousemove', onMouseMove)
            animateBlobs()
        })
        onBeforeUnmount(() => {
            window.removeEventListener('mousemove', onMouseMove)
            cancelAnimationFrame(animationId)
        })
        return { blob1, blob2, blob3 }
    }
}
</script>

<style>
.blob-gradient {
    position: fixed;
    width: 200px;
    height: 200px;
    pointer-events: none;
    z-index: 0;
    border-radius: 50%;
    filter: blur(50px) brightness(1.0);
    opacity: 0.5;
    mix-blend-mode: lighten;
    transition: left 0.1s cubic-bezier(.55, 0, .1, 1), top 0.1s cubic-bezier(.55, 0, .1, 1);
}

.blob1 {
    background: radial-gradient(circle at 30% 30%, #60a5fa 0%, #a78bfa 60%, #f472b6 100%);
}

.blob2 {
    background: radial-gradient(circle at 70% 30%, #f472b6 0%, #fbbf24 60%, #60a5fa 100%);
}

.blob3 {
    background: radial-gradient(circle at 50% 70%, #a78bfa 0%, #34d399 60%, #f472b6 100%);
}
</style>
